(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('clicktimeProtectionDao', ["http", "path", function (http, path) {
        return {
            list: function (listid) {
                if (listid === 0 || listid) {
                    return http.get('/api/v1/clicktime_protection/lists/' + listid.toString());
                }
                return http.get('/api/v1/clicktime_protection/lists');
            },
            listitem: function (listitemid) {
                // return http.get(path('gui-v2').ctrl('clicktime-protection-list-management').json('list').path);
                if (listitemid === 0 || listitemid) {
                    return http.get('/api/v1/clicktime_protection/list_items/' + listitemid.toString());
                }
                return http.get('/api/v1/clicktime_protection/list_items');
            },
            addListitem: function (data) {
                // data is array
                // example format: [{"listitemname":"malware.com","listid":"0"}]
                return http.post('/api/v1/clicktime_protection/list_items').body(data).run();
            },
            updateListitem: function (listitemid, data) {
                // data is array
                // example format: [{"listitemid":"0","listitemname":"malware.com","listid":"2"}]
                return http.put('/api/v1/clicktime_protection/list_items/' + listitemid.toString()).body(data).run();
            },
            updateListitems: function (data) {
                // data is array
                // example format: [
                // {"listitemid":"0","listitemname":"mmmmalware.com","listid":"2"},
                // {"listitemid":"1","listitemname":"1111alware.com","listid":"2"},
                // {"listitemid":"2","listitemname":"2222lware.com","listid":"2"}
                // ]
                return http.post('/api/v1/clicktime_protection/list_items/updateListItems').body(data).run();
            },
            removeListitem: function (listitemid) {
                return http.delete('/api/v1/clicktime_protection/list_items/' + listitemid.toString()).run();
            },
            removeListitems: function (listitemids) {
                // listitemids is a string of ids.
                // example: '0,1,2,5'
                return http.delete('/api/v1/clicktime_protection/list_items?listitemid=' + listitemids).run();
            }
        };
    }]);
}());